import { admin, admin2 } from '@/api/instance'

const config = (shopId) => {
  return `/${shopId}/memberConfig`
}

const baseUrl = (shopId) => {
  return `/${shopId}/member`
}

//= > 取得會員
export const GetMembersNew = async ({
  shopId,
  start,
  limit,
  name,
  phone,
  address,
  addressCode,
  gender,
  birthdayMonth,
  mTagId,
  existPhone,
  search,
  customKey,
  customValue,
  customParentValue,
  customChildValue,
  memberAuthLineDisplayName,
  showSalesRecordTotalPaymentPriceSum = false,
}) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}`,
    params: {
      start,
      limit,
      name,
      phone,
      birthdayMonth,
      address,
      addressCode,
      gender,
      mTagId,
      existPhone,
      search,
      customKey,
      customValue,
      customParentValue,
      customChildValue,
      memberAuthLineDisplayName,
      showSalesRecordTotalPaymentPriceSum,
    },
  })
}

//= > 取得會員總數
export const GetMembersCountNew = async ({
  shopId,
  name,
  phone,
  search,
  address,
  addressCode,
  gender,
  customKey,
  customValue,
  customParentValue,
  customChildValue,
  birthdayMonth,
  mTagId,
  memberAuthLineDisplayName,
}) => {
  return await admin2({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
      phone,
      address,
      addressCode,
      gender,
      search,
      customKey,
      customValue,
      customParentValue,
      customChildValue,
      birthdayMonth,
      mTagId,
      memberAuthLineDisplayName,
    },
  })
}

//= > 取得會員
export const GetMembers = async ({
  shopId,
  start,
  limit,
  name,
  phone,
  search,
  address,
  addressCode,
  gender,
  email,
  customKey,
  customValue,
  customParentValue,
  customChildValue,
  birthdayMonth,
  mTagId,
  existPhone,
  showSalesRecordTotalPaymentPriceSum = false,
  memberAuthLineDisplayName,
}) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}`,
    params: {
      start,
      limit,
      name,
      phone,
      address,
      addressCode,
      gender,
      search,
      birthdayMonth,
      mTagId,
      existPhone,
      showSalesRecordTotalPaymentPriceSum,
      email,
      customKey,
      customValue,
      customParentValue,
      customChildValue,
      memberAuthLineDisplayName,
    },
  })

  return res.data
}

//= > 取得會員總數
export const GetMembersCount = async ({
  shopId,
  name,
  phone,
  search,
  address,
  addressCode,
  gender,
  birthdayMonth,
  mTagId,
  email,
  customKey,
  customValue,
  customParentValue,
  customChildValue,
  memberAuthLineDisplayName,
}) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}/count`,
    params: {
      name,
      phone,
      search,
      address,
      addressCode,
      gender,
      birthdayMonth,
      mTagId,
      email,
      customKey,
      customValue,
      customParentValue,
      customChildValue,
      memberAuthLineDisplayName,
    },
  })

  return res.data.count
}

//= > 查找指定會員
export const FindMember = async ({ shopId, id, phone }) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}`,
    params: {
      phone,
    },
  })

  return res.data
}

/**
 * 更新會員資料 admin.member.update
 * @param {Object} params - 更新參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 會員ID
 * @param {string} [params.memberStatus] - 會員狀態 ('normal' | 'warning' | 'blocked')
 * @param {number} [params.level] - 會員等級
 * @param {string} [params.name] - 姓名
 * @param {string} [params.phone] - 電話號碼
 * @param {string} [params.address] - 地址
 * @param {Array} [params.mTags] - 標籤ID列表
 * @param {string} [params.birthday] - 生日
 * @param {string} [params.gender] - 性別
 * @param {string} [params.email] - 電子郵件
 * @param {Object} [params.custom] - 自定義欄位
 * @param {string} [params.levelExpiredAt] - 等級到期日
 * @param {string} [params.levelNote] - 等級備註
 * @param {boolean} [params.isLevelRemainFulfilled] - 是否保留等級滿條件
 * @param {string} [params.recognizedTimeReset] - 消費認列起始日重置方式 ('noChange' | 'fromUpgradeDay' | 'fromDaysBeforeUpgrade' | 'fromRenewalDay' | 'fromDaysBeforeRenewal')
 * @param {number} [params.recognizedTimeResetValue] - 等級異動前 x 天（recognizedTimeReset 為 'fromDaysBeforeUpgrade' 時使用）
 * @returns {Promise<Object>} 更新後的會員資料
 */
export const UpdateMember = async ({
  shopId,
  id,
  memberStatus,
  level,
  name,
  phone,
  address,
  mTags,
  birthday,
  gender,
  email,
  custom,
  levelExpiredAt,
  levelNote,
  isLevelRemainFulfilled,
  recognizedTimeReset,
  recognizedTimeResetValue,
}) => {
  const res = await admin({
    method: 'put',
    url: `${baseUrl(shopId)}/${id}`,
    data: {
      memberStatus,
      level,
      name,
      phone,
      address,
      mTags,
      birthday,
      gender,
      email,
      custom,
      levelExpiredAt,
      levelNote,
      isLevelRemainFulfilled,
      recognizedTimeReset,
      recognizedTimeResetValue,
    },
  })

  return res.data
}

// => 查找指定會員儲值金紀錄
export const FindDepositWalletRecord = async ({
  shopId,
  id,
  start,
  limit,
  operationShopId,
}) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}/walletRecord`,
    params: {
      start,
      limit,
      operationShopId,
    },
  })

  return res.data
}

// => 查找指定會員儲值金紀錄總數
export const DepositWalletRecordCount = async ({
  shopId,
  id,
  operationShopId,
}) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}/walletRecord/count`,
    params: {
      operationShopId,
    },
  })

  return res.data.count
}

//= > 給予指定會員儲值金紀錄
export const GiveDepositWallet = async ({ shopId, id, amount, note }) => {
  const res = await admin({
    method: 'post',
    url: `${baseUrl(shopId)}/${id}/depositWallet`,
    data: {
      amount,
      note,
    },
  })

  return res.data
}

//= > 使用指定會員儲值金
export const UseDepositWallet = async ({ shopId, id, amount, note }) => {
  const res = await admin({
    method: 'post',
    url: `${baseUrl(shopId)}/${id}/adminUseWallet`,
    data: {
      amount,
      note,
    },
  })

  return res.data
}

export const MemberConfig = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `${config(shopId)}`,
  })

  return res
}

export const sentLineMessage = async ({
  shopId,
  id,
  useMulticast,
  messages,
}) => {
  const res = await admin({
    method: 'post',
    url: `${baseUrl(shopId)}/${id}/sentLineMessage`,
    data: {
      useMulticast,
      messages,
    },
  })

  return res.data
}

export const GetMemberTotalPaymentPriceSum = async ({ shopId, id }) => {
  const res = await admin({
    method: 'get',
    url: `${baseUrl(shopId)}/${id}/totalPaymentPriceSum`,
  })

  return res.data
}

//= > 取得會員頂部資訊 (admin.member.getTopInfo)
export const GetMemberTopInfo = async ({ shopId, id }) => {
  // 此 endpoint 回傳大量組合資料，使用 admin2 保留原始 [data, err] 回傳風格
  return await admin2({
    method: 'get',
    url: `/${shopId}/member/${id}/getTopInfo`,
  })
}
/**
 * admin.member.deleteMemberAuthLine
 * 會員解除LINE綁定
 * @param {Object} param0
 * @param {string} param0.shopId - 店家ID
 * @param {string} param0.id - 會員ID
 */
export const DeleteMemberAuthLine = async ({ shopId, id }) => {
  return await admin2({
    method: 'delete',
    url: `/${shopId}/member/${id}/memberAuthLine`,
  })
}

/**
 * admin.member.getMemberAuthLine
 * 取得會員 LINE 認證資料
 * @param {Object} params
 * @param {string} params.shopId - 店家ID
 * @param {string} params.memberId - 會員ID
 */
export const GetMemberAuthLine = async ({ shopId, memberId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/member/${memberId}/getMemberAuthLine`,
  })
}

/**
 * admin.member.refreshLineProfile
 * 刷新會員 LINE 個人資料
 * @param {Object} params
 * @param {string} params.shopId - 店家ID
 * @param {string} params.memberId - 會員ID
 */
export const RefreshMemberLineProfile = async ({ shopId, memberId }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/member/${memberId}/refreshMemberLineProfile`,
    data: {},
  })
}

/**
 * 檢查手機號碼是否已註冊 admin.registerMember.checkUserByPhone
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.phone - 查詢用手機號碼
 * @returns {Promise<Array>} 會員與使用者查詢結果
 */
export const CheckUserPhone = async ({ shopId, phone }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/registerMember/checkUserByPhone`,
    params: {
      phone,
    },
  })
}

/**
 * 以手機號碼建立組織使用者 admin.registerMember.createUserByPhone
 * @param {Object} params - 建立參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.phone - 本地手機號碼
 * @param {string} [params.phoneCountryCode] - 國際碼
 * @param {string} [params.phoneCountry] - 國家 ISO alpha-2 代碼
 * @param {Object} [params.info] - 會員資訊
 * @param {Object} [params.custom] - 自定義欄位
 * @returns {Promise<Array>} 建立結果
 */
export const CreateUserByPhone = async ({ shopId, phone, phoneCountryCode, phoneCountry, info, custom }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/registerMember/createUserByPhone`,
    data: {
      phone,
      phoneCountryCode,
      phoneCountry,
      info,
      custom,
    },
  })
}
export const RegisterShopMemberByUser = async ({ shopId, userId }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/registerMember/registerShopMemberByUser`,
    data: {
      userId,
    },
  })
}

export const GetUserMoreInfoAddress = async ({ shopId, memberId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/member/${memberId}/userInfoMoreAddress`,
  })
}

export const FindOnePointWallet = async ({ shopId, memberId, shopPointKey }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/member/${memberId}/pointWallet`,
    params: {
      shopPointKey,
    },
  })
}

/**
 * admin.memberQuery.searchMember
 * 搜尋會員
 * @param {Object} params
 * @param {string} params.shopId - 店家ID
 * @param {string} params.search - 搜尋關鍵字
 * @param {string} params.memberId - 會員ID
 * @return {import('@/api/instance').Api2Response<Array<{
 *   id: string
 *   memberId: string
 *   name: string
 *   phone: string
 *   userId: string
 *   level: number
 *   memberStatus: string
 * }>>}
 */
export const GetMemberQuerySearchMember = async ({ shopId, search, memberId }) => {
  return await admin2({
    url: `/${shopId}/memberQuery/searchMember`,
    method: 'GET',
    params: { search, memberId },
  })
}

export const QuickRegister = async ({ shopId, phone, name }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/registerMember/quickRegister`,
    data: {
      phone,
      name,
    },
  })
}
